import { ReactNode } from 'react'
import { useUserInfo } from '@mc/user-info'
import { useIsEnterpriseAnnouncementEnabled } from './useIsEnterpriseAnnouncementEnabled'

export const AnnouncementWrapper = ({ children }: { children: ReactNode }) => {
  const { user } = useUserInfo()
  const { enterpriseAnnouncementEnabled } = useIsEnterpriseAnnouncementEnabled()

  if (
    !enterpriseAnnouncementEnabled ||
    !user?.organizationsAdministered?.length
  )
    return null

  return children
}
